<template>
    <div>
        <div class="form-group no-gutters mt-4 peak-sans">
            <div class="col-md-12">
                <label for="first_name" class="form-control-label col-md-12 text-bold">Email</label>
                <div class="col-md-12">
                    <input type="email" class="form-control" placeholder="email@email.com" maxlength="191" v-model="rebate.email" required  name="email" value="">
                </div>
            </div>
        </div>
        <div class="form-group no-gutters mb-4">
            <div class="col-md-12">
                <label for="first_name" class="form-control-label col-md-12 text-bold">Confirmation Code</label>
                <div class="col-md-12">
                    <input type="text" class="form-control text-uppercase" placeholder="S##XXXXX" maxlength="8" v-model="rebate.confirmation" required  name="email" value="">
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col text-center">
                <button type="submit" v-on:click="checkRebate()" class="show-btn">SUBMIT</button>
            </div><!--col-->
        </div><!--row-->
        <validation-errors ref="validationErrors"></validation-errors>
    </div>
</template>
<script>

export default {
    name:"RebateCheckComponent",
    mounted(){

    },
    data() {
        return {
            rebate:{
                email:'',
                confirmation:''
            },
            disabled:false
        }
    },
    methods: {
        checkRebate() {
            this.$store.state.errors={}
            this.$store.dispatch('checkRebate', this.rebate)
        }
    },
 }
</script>
